// extracted by mini-css-extract-plugin
module.exports = {"header":"EmailChangePassword_header__2kz3_"};